import { usePomodoroTimer } from '@hooks/use-pomodoro-timer.hook'

const PomodoroTimerManager = () => {
  usePomodoroTimer()

  return null
}

export { PomodoroTimerManager }
